import axios from 'axios';

export default {
	/* PROCESOS */
    buscarProcedimiento(p_email, p_usuario, p_gspnombre, p_tiporec) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_genpp_procedimientos.recuperar",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_gspnombre": p_gspnombre,
					"p_tiporec": p_tiporec
				  })
			})
    },

    eliminarProcedimiento(p_email, p_usuario, p_gspnombre) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_genpp_procedimientos.eliminar",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_gspnombre": p_gspnombre
				  })
			})
	},

	activarProcedimiento(p_email, p_usuario, p_gspnombre) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_genpp_procedimientos.activar",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_gspnombre": p_gspnombre
				  })
			})
    },
    
	pre_insertarProcedimiento(p_email, p_usuario, gspnombre) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_genpp_procedimientos.pre_insercion",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_gspnombre": gspnombre
				  })
			})
	},

	insertarProcedimiento(p_email, p_usuario, datosFormulario) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_genpp_procedimientos.insertar",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_gspnombre": datosFormulario.gspnombre,
					"p_gspdescripcion": datosFormulario.gspdescripcion,
					"p_gspclave1": datosFormulario.gspclave1,
					"p_gspclave2": datosFormulario.gspclave2,
					"p_gspclave3": datosFormulario.gspclave3,
                    "p_gspiniestado": datosFormulario.gspiniestado,
					"p_gspiniactivi": datosFormulario.gspiniactivi,
					"p_gsptipo": datosFormulario.gsptipo
				  })
			})
	},

	modificarProcedimiento(p_email, p_usuario, datosFormulario) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_genpp_procedimientos.modificar",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_gspnombre": datosFormulario.gspnombre,
					"p_gspdescripcion": datosFormulario.gspdescripcion,
					"p_gspclave1": datosFormulario.gspclave1,
					"p_gspclave2": datosFormulario.gspclave2,
					"p_gspclave3": datosFormulario.gspclave3,
                    "p_gspiniestado": datosFormulario.gspiniestado,
					"p_gspiniactivi": datosFormulario.gspiniactivi,
					"p_gsptipo": datosFormulario.gsptipo
				  })
			})
	},

	/* ACTIVIDADES */
	buscarActividad(p_email, p_usuario, p_gsaproced, p_gsanombre, p_tiporec) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_genpp_actividades.recuperar",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_gsaproced": p_gsaproced,
					"p_gsanombre": p_gsanombre,
					"p_tiporec": p_tiporec
				  })
			})
	},
	
	eliminarActividad(p_email, p_usuario, p_gsaproced, p_gsanombre) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_genpp_actividades.eliminar",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_gsaproced": p_gsaproced,
					"p_gsanombre": p_gsanombre
				  })
			})
	},

	activarActividad(p_email, p_usuario, p_gsaproced, p_gsanombre) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_genpp_actividades.activar",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_gsaproced": p_gsaproced,
					"p_gsanombre": p_gsanombre
				  })
			})
	},
	
	pre_insertarActividad(p_email, p_usuario, p_gsaproced, p_gsanombre) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_genpp_actividades.pre_insercion",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_gsaproced": p_gsaproced,
					"p_gsanombre": p_gsanombre
				  })
			})
	},

	insertarActividad(p_email, p_usuario, datosFormulario) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_genpp_actividades.insertar",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_gsaproced": datosFormulario.gsaproced,
					"p_gsanombre": datosFormulario.gsanombre,
					"p_gsadescripcion": datosFormulario.gsadescripcion,
					"p_gsaautomatica": datosFormulario.gsaautomatica,
					"p_gsasecuencia": datosFormulario.gsasecuencia,
					"p_gsapantalla": datosFormulario.gsapantalla,
                    "p_gsaproceso": datosFormulario.gsaproceso,
					"p_gsaprocestado": datosFormulario.gsaprocestado,
					"p_gsafrecuencia": datosFormulario.gsafrecuencia,
					"p_gsaplazo": datosFormulario.gsaplazo,
					"p_gsadiaprogramado": datosFormulario.gsadiaprogramado,
					"p_gspiniestado": datosFormulario.gspiniestado,
					"p_gspiniactivi": datosFormulario.gspiniactivi,
				  })
			})
	},

	modificarActividad(p_email, p_usuario, datosFormulario) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_genpp_actividades.modificar",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_gsaproced": datosFormulario.gsaproced,
					"p_gsanombre": datosFormulario.gsanombre,
					"p_gsadescripcion": datosFormulario.gsadescripcion,
					"p_gsaautomatica": datosFormulario.gsaautomatica,
					"p_gsasecuencia": datosFormulario.gsasecuencia,
					"p_gsapantalla": datosFormulario.gsapantalla,
                    "p_gsaproceso": datosFormulario.gsaproceso,
					"p_gsaprocestado": datosFormulario.gsaprocestado,
					"p_gsafrecuencia": datosFormulario.gsafrecuencia,
					"p_gsaplazo": datosFormulario.gsaplazo,
					"p_gsadiaprogramado": datosFormulario.gsadiaprogramado,
					"p_gspiniestado": datosFormulario.gspiniestado,
					"p_gspiniactivi": datosFormulario.gspiniactivi
				  })
			})
	},
	
	/* ESTADOS */
	buscarEstado(p_email, p_usuario, p_gsaproced, p_gpecodigo, p_tiporec) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_genpp_proest.recuperar",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_gpeproced": p_gsaproced,
					"p_gpecodigo": p_gpecodigo,
					"p_tiporec": p_tiporec
				  })
			})
	},
	
	eliminarEstado(p_email, p_usuario, p_gsaproced, p_gpecodigo) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_genpp_proest.eliminar",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_gpeproced": p_gsaproced,
					"p_gpecodigo": p_gpecodigo
				  })
			})
	},

	activarEstado(p_email, p_usuario, p_gsaproced, p_gpecodigo) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_genpp_proest.activar",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_gpeproced": p_gsaproced,
					"p_gpecodigo": p_gpecodigo
				  })
			})
	},

	pre_insertarEstado(p_email, p_usuario, p_gsaproced, p_gpecodigo) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_genpp_proest.pre_insercion",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_gpeproced": p_gsaproced,
					"p_gpecodigo": p_gpecodigo
				  })
			})
	},

	insertarEstado(p_email, p_usuario, datosFormulario) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_genpp_proest.insertar",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_gpeproced": datosFormulario.gpeproced,
					"p_gpecodigo": datosFormulario.gpecodigo,
					"p_gpesecuencia" : null,
					"p_gpedescripcion": datosFormulario.gpedescripcion,
					"p_gpeefecto": datosFormulario.gpeefecto,
					"p_gspiniestado": datosFormulario.gspiniestado
				  })
			})
	},

	modificarEstado(p_email, p_usuario, datosFormulario) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_genpp_proest.modificar",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_gpeproced": datosFormulario.gpeproced,
					"p_gpecodigo": datosFormulario.gpecodigo,
					"p_gpesecuencia" : null,
					"p_gpedescripcion": datosFormulario.gpedescripcion,
					"p_gpeefecto": datosFormulario.gpeefecto,
					"p_gspiniestado": datosFormulario.gspiniestado
				  })
			})
	},

	/* RESULTADOS */
	buscarResultado(p_email, p_usuario, p_garproced, p_garactivi, p_garcodigo, p_tiporec) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_genpp_actres.recuperar",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_garproced": p_garproced,
					"p_garactivi": p_garactivi,
					"p_garcodigo": p_garcodigo,
					"p_tiporec": p_tiporec
				  })
			})
	},

	eliminarResultado(p_email, p_usuario, p_garproced, p_garactivi, p_garcodigo) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_genpp_actres.eliminar",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_garproced": p_garproced,
					"p_garactivi": p_garactivi,
					"p_garcodigo": p_garcodigo
				  })
			})
	},

	activarResultado(p_email, p_usuario, p_garproced, p_garactivi, p_garcodigo) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_genpp_actres.activar",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_garproced": p_garproced,
					"p_garactivi": p_garactivi,
					"p_garcodigo": p_garcodigo
				  })
			})
	},

	/* DEPENDENCIAS */
	buscarDependencia(p_email, p_usuario, p_graproced, p_gracodigo, p_tiporec) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_genpp_actreq.recuperar",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_graproced": p_graproced,
					"p_gracodigo": p_gracodigo,
					"p_tiporec": p_tiporec
				  })
			})
	},

	pre_insertarDependencia(p_email, p_usuario, p_graproced, p_gracodigo) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_genpp_actreq.pre_insercion",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_graproced": p_graproced,
					"p_gracodigo": p_gracodigo
				  })
			})
	},

	insertarDependencia(p_email, p_usuario, datosFormulario) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_genpp_actreq.insertar",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_graproced": datosFormulario.graproced,
					"p_graactivi": datosFormulario.graactivi,
					"p_grarequis" : datosFormulario.grarequis,
					"p_grasecuencia": null,
					"p_graresultado": null
				  })
			})
	},

	modificarDependencia(p_email, p_usuario, datosFormulario) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_genpp_actreq.modificar",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_graproced": datosFormulario.graproced,
					"p_graactivi": datosFormulario.graactivi,
					"p_grarequis" : datosFormulario.grarequis,
					"p_grasecuencia": null,
					"p_graresultado": null
				  })
			})
	},

	eliminarDependencia(p_email, p_usuario, p_gracodigo) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_genpp_actreq.eliminar",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_gracodigo": p_gracodigo
				  })
			})
	},

	activarDependencia(p_email, p_usuario, p_gracodigo) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_genpp_actreq.activar",
				"p_args_in": JSON.stringify({
					"p_usuario": p_usuario,
					"p_gracodigo": p_gracodigo
				  })
			})
	},
}